import compraReducer from './compraReducer';

export default compraReducer;